import React, { useEffect, useState } from "react";
import "./index.css";
import { Link, useNavigate } from "react-router-dom";
import { login, refreshToken } from "../../functions/auth";
import { useDispatch } from "react-redux";
import { userauthReducer } from "../../components/toolkit/authReducer";
import Cookies from "universal-cookie";
import { toast } from "react-toastify";
import Loading from "../../modal/Loading";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { setPermissions } from "../../components/toolkit/permissions/index";
import ReCAPTCHA from "react-google-recaptcha";
const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [eye, setEye] = useState(false);
  const [captchaToken, setCaptchaToken] = useState(null);
  const [showCaptcha, setShowCaptcha] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const cookies = new Cookies();


  const onEyeClick = () => {
    setEye(!eye);
  };

  // console.log(eye);

  const loginform = () => (
    <form>
      <div className="form-group mt-4">
        <input
          type="email"
          className="form-control"
          value={email}
          name="email"
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Email"
          autoFocus
          autoComplete="true" //off
        />
      </div>
      <div className="form-group mt-3" style={{ position: "relative" }}>
        <input
          type={eye ? "text" : "password"}
          className="form-control"
          value={password}
          name="password"
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Password"
          autoComplete="true"
        />
        <span
          style={{ position: "absolute", right: "10px", top: "20%" }}
          onClick={onEyeClick}
        >
          {eye ? <FaEyeSlash /> : <FaEye />}
        </span>
      </div>
      {showCaptcha && (
        <div className="form-group mt-3" style={{ display: "flex", justifyContent: "center" }}>
          <ReCAPTCHA
            sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
            onChange={(token) => setCaptchaToken(token)}
            onExpired={() => setCaptchaToken(null)}
          />
        </div>
      )}
      <button
        onClick={handleSubmit}
        className="mb-3 mt-3 w-100 btnlogin"
        disabled={loading || !email || password.length < 6 || (showCaptcha && !captchaToken)}
      >
        {loading ? <div>Loading...</div> : <div>Log In</div>}
      </button>
    </form>
  );

  const isRoleCheck = ["admin", "HQ"]
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const options = captchaToken ? { captchaToken, captchaType: 'recaptcha' } : undefined;
      await login(email, password, options)
        .then((res) => {
          const list = res.data.user.permissions;
          dispatch(setPermissions(list));
          // if (res.data.user.role === "user") {
          // if (isRoleCheck.includes()) {
          const userData = res.data.user;
          setLoading(false);
          if (userData.twoFactorSetupRequired) {
            navigate("/setup", { state: { data: res.data }});
          } else if (userData.twoFactorVerificationRequired === true) {
            navigate("/verify", { state: { data: res.data }});
          }
          else if (userData.twoFactorVerificationRequired === false) {
            cookies.set("token", res.data?.token?.accessToken, {
              expires: new Date(new Date().getTime() + 7 * 60 * 60 * 1000),
              maxAge: 7 * 60 * 60,
            });
            cookies.set("refreshToken", res.data.token.refreshToken, {
              expires: new Date(new Date().getTime() + 7 * 60 * 60 * 1000),
              maxAge: 7 * 60 * 60, 
            });
            cookies.set("userName", res.data.user.email);
            cookies.set("userId", res.data.user.id);
            cookies.set("name", res.data.user.name);
            localStorage.setItem("userData", JSON.stringify(res.data.user));
            navigate("/dashboard");
            toast.success("You have log in successfully.")
          }  
          setLoading(false);
        })
        .catch((err) => {
          if (err?.response?.data?.captchaRequired) {
            setShowCaptcha(true);
            setCaptchaToken(null);
          }
          toast.error(
            err.response.data.message || "Incorrect email or password."
          );
          setLoading(false);
        });
    } catch (error) {
      toast.error(error || "User not found.");
    }
  };
 
  return (
    <div className="container1">
      {loading && <Loading />}
      <div className="loginheader">
        <div className="d-flex gap-2 justify-content-center">
          <img
            alt=""
            src="/images/Union.png"
            style={{ width: "30px", height: "24px" }}
          />
          <h2 className="header">Pronto</h2>
        </div>
      </div>
      {/* <div className="logingraphic position-relative">
        <div style={{ display: "flex", justifyContent: "center" }}>
          <img src="./images/front.png" alt="" className="imageCls" />
        </div>
      </div> */}
      <div className="pcont">
        <div className="p-4">
          <div className="row">
            <div className="col-md-4 offset-md-4">
              <img
                alt=""
                src="/images/group.png"
                style={{
                  width: "9rem",
                  height: "8rem",
                  display: "flex",
                  margin: "auto",
                }}
              />
              <div className="textJ">Pronto</div>
              <div
                className="textJ mt-2"
                style={{ fontSize: "12px", fontWeight: "400" }}
              >
                Powered by <div>Health Monitor</div>
              </div>

              {loginform()}

              <div
                className="textJ"
                style={{
                  fontSize: "14px",
                  fontWeight: "500",
                  textDecorationLine: "underline",
                  color: "black",
                }}
              >
                <Link
                  to="/forgot-password"
                  style={{
                    color: "black",
                  }}
                >
                  Forgot Password?
                </Link>
              </div>

              <div
                className="textJ mt-1"
                style={{ fontSize: "14px", fontWeight: "500", color: "black" }}
              >
                Admin Login
              </div>
              {/* <div
                className="textJ mt-3"
                style={{ fontSize: "14px", fontWeight: "500", color: "black" }}
              >
                Don’t have an Account?{" "}
                <span style={{ textDecorationLine: "underline" }}>Sign Up</span>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
